/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const CALENDAR_SLOTS_FETCH = gql`
  query calendarSlotsFetchNoId($source: CalendarRecordTypeEnum!, $search: SearchFilterInput, $sort: SortInput, $page: Int, $limit: Int, $extensionDays: Int) {
    calendar {
      slots(source: $source, search: $search, sort: $sort, page: $page, limit: $limit, extensionDays: $extensionDays) {
        collection {
          id
          available
          startTime
          endTime
          calendarId
        }

        metadata {
          ...pagemetadata
        }

        poolCalendarIds
      }
    }
  }

  fragment pagemetadata on CollectionMetadata {
    totalPages
    totalCount
    currentPage
    limitValue
  }
`;
